import React from 'react';
import Header from '../components/site/Header';
import Hero from '../components/site/Hero';
import Services from '../components/site/Services';
import About from '../components/site/About';
import Repairs from '../components/site/Repairs';
import Brands from '../components/site/Brands';
import Contact from '../components/site/Contact';
import Footer from '../components/site/Footer';
import FloatingWhatsApp from '../components/site/FloatingWhatsApp';
import CookieBanner from '../components/site/CookieBanner';
import { Toaster } from '../components/ui/toaster';

export default function Home() {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Repairs />
        <Brands />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <CookieBanner />
      <Toaster />
    </div>
  );
}
